import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'
import numeral from 'numeral'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'Project Name',
        width: 300,
        dataIndex: 'name'
      },
      {
        title: 'Address',
        width: 200,
        dataIndex: 'address'
      },
      {
        title: 'Company',
        width: 200,
        dataIndex: 'company_name'
      },
      {
        title: 'Primary Contact',
        dataIndex: 'contact'
      },
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date',
        width: 100
      }
    ]
  }

  getOverviewColumns = () => {
    return [
      {
        title: 'Status',
        dataIndex: 'status'
      },
      {
        title: 'Total',
        dataIndex: 'total'
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    return fullReport.map((item, index) => {
      item.created_date = moment(new Date(item.created_date)).format('YYYY-MM-DD')
      item.amount = numeral(item.amount).format('$0,0.00')
      item.contact = `${item.contact_first_name} ${item.contact_last_name}`
      item.address = `${item.address1}${item.address2 ? ', ' + item.address2 : ''}, ${item.city}, ${
        item.state
      }`
      item.key = item.id
      return item
    })
  }

  getOverviewData = () => {
    const { fullReport } = this.props

    var data = []
    data.push({
      key: 0,
      status: 'Proposal',
      total: fullReport.filter(
        item => item.status !== null && item.status.toLowerCase() === 'proposal'
      ).length
    })
    data.push({
      key: 1,
      status: 'Dead',
      total: fullReport.filter(item => item.status !== null && item.status.toLowerCase() === 'dead')
        .length
    })
    data.push({
      key: 2,
      status: 'Research',
      total: fullReport.filter(
        item => item.status !== null && item.status.toLowerCase() === 'research'
      ).length
    })
    data.push({
      key: 3,
      status: 'Contract',
      total: fullReport.filter(
        item => item.status !== null && item.status.toLowerCase() === 'contract'
      ).length
    })
    data.push({
      key: 4,
      status: 'Estimate',
      total: fullReport.filter(
        item => item.status !== null && item.status.toLowerCase() === 'estimate'
      ).length
    })
    data.push({
      key: 5,
      status: 'Completed',
      total: fullReport.filter(
        item => item.status !== null && item.status.toLowerCase() === 'completed'
      ).length
    })
    data.push({
      key: 6,
      status: 'Total',
      total: fullReport.length
    })
    return data
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Overview</h5>
                </div>
              </div>
              <Table
                rowClassName={(record, index) => {
                  if (record.status === 'Total') return 'jobDetailsHeader'
                }}
                pagination={false}
                columns={this.getOverviewColumns()}
                dataSource={this.getOverviewData()}
                size="small"
                style={{ backgroundColor: 'white' }}
              />
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Leads</h5>
                </div>
              </div>
              <Table
                pagination={false}
                columns={this.getColumns()}
                dataSource={this.getData()}
                size="small"
                style={{ backgroundColor: 'white' }}
              />
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/leads/leads/ListItem.js